import ListAltIcon from '@material-ui/icons/ShortText';

const StructuralReviewerSubItem = () => {
  const links = {
    subheader: 'Structural Reviewer Submenu',
    owner: 'structural-reviewer',
    items: [
      {
        title: 'Processed Permits',
        icon: ListAltIcon,
        href: '/structural-reviewer/reviewed/request/permit/approved-list',
        enabled: true
      },

      {
        title: 'Processed Permits For Occupancy',
        icon: ListAltIcon,
        href:
          '/structural-reviewer/reviewed/request/occupancy/permit/approved-list',
        enabled: true
      }
    ]
  };

  return links;
};

export default StructuralReviewerSubItem;
